import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDateString, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class CostDocumentBuffer {
  @IsString()
  @Expose()
  id!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  receiptDate!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsOptional()
  @IsString()
  @Expose()
  ksefNumber!: string | null;
  @IsOptional()
  @IsDateString()
  @Expose()
  ksefAcquisitionDate!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  sellerName!: string | null;
  @IsBoolean()
  @Expose()
  disableMoveButton!: boolean;
  @IsArray()
  @Expose()
  files!: Array<CostDocumentBufferFile>;
}

export class CostDocumentBufferFile {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  name!: string;
}

export class CostDocumentBufferResponse extends GenericTableResponse<CostDocumentBuffer> {
  @Type(() => CostDocumentBuffer)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CostDocumentBuffer>;
}
